import React from "react";

export default class FrontEcheancier extends React.Component {
    
    constructor(props) {
        super(props);
    }

    render() {
        const {devis,focusError,showValidate} = this.props.container
        const params = devis.params
        const now = new Date()
        let year = now.getFullYear()
        let month = now.getMonth()
        const incMonth = () => {
            month += 1
            if ( month >= 12 ) {
                year += 1
                month = 0
            }
        }
        const monthToDisplay = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Sept.','Oct.','Nov.','Déc.']

        let cells1 = []
        for ( let i = 0 ; i < 6 ; i++ ) {
            cells1.push(<th key={i}>{(!i)?'Acompte ':''}{monthToDisplay[month]}<br/>{year}<br/><span>TTC</span></th>)
            incMonth()
        }

        let cells2 = []
        for ( let i = 0 ; i < 6 ; i++ ) {
            cells2.push(<th key={i}>{monthToDisplay[month]}<br/>{year}<br/><span>TTC</span></th>)
            incMonth()
        }

        let tcells1 = []
        tcells1.push(<td key="0" className="even">{devis.toPay()} €</td>)
        tcells1.push(<td key="1" className="odd">0 €</td>)
        for ( let i = 2 ; i < 6 ; i++ ) {
            tcells1.push(<td key={i} className={(i%2)?'odd':'even'}>{(params.periodicite=='M')?devis.toPayMonthly(params.formule):0} €</td>)
        }
        let tcells2 = []
        for ( let i = 0 ; i < 6 ; i++ ) {
            tcells2.push(<td key={i} className={(i%2)?'odd':'even'}>{(params.periodicite=='M')?devis.toPayMonthly(params.formule):0} €</td>)
        }


        return <div className={this.props.hidden ? 'collapsable hidden' : 'collapsable'}>
                <table className="echeancier">
                <tbody>
                    <tr>{cells1}</tr>
                    <tr>{tcells1}</tr>
                    <tr>{cells2}</tr>
                    <tr>{tcells2}</tr>
                </tbody>
            </table>
        </div>
    }
}